import React, {useState, useEffect} from "react";
import Interest_form_item from "./interest_form_item";

function InterestForm( { api } ) {
    const [ data, setData ] = useState([]);
    const [ selectedInterestes, setSelectedInterests] = useState(false)
    const [ loading, setLoading ] = useState(true)
    const staticButtonClasses = [ 'button-fill' ];
    const [ buttonClasses, setButtonClasses ] = useState('button-fill loading' )

    const interestsSelected = async (interest) => {
      if (interest.checked === true) {
        let newInterests = selectedInterestes;
        newInterests.push(interest);
        await setSelectedInterests(newInterests);
      }
      else {
        let newInterests = [];
        for (let item in selectedInterestes) {
          if (selectedInterestes[item].id != interest.id) {
            newInterests.push(selectedInterestes[item]);
          }
        }
        await setSelectedInterests(newInterests);
      }
    }

    useEffect( () => {
        const fetchData = async () => {
            await setLoading( true );
            const data = await fetch(api);
            // convert data to json
            const json = await data.json();
            // set state with the result
            await setData(json.interest);

            if (!selectedInterestes) {
              let initalInterests = [];
              for (let item in json.interest) {
                if (json.interest[item].checked) {
                  initalInterests.push(json.interest[item]);
                }
              }
              await setSelectedInterests(initalInterests);
            }
        }

        fetchData().catch( fault => {
          console.log(fault);
        }).then(async () => {
          await setLoading(false);
        });

    },[ ]);

    useEffect( () => {
      const updateButtonClasses = async() => {
        let _class = staticButtonClasses;
        if (loading) {
          _class.push('loading');
        }

        // console.log(_class);
        await setButtonClasses(_class.join(' '));
      };

      updateButtonClasses().catch( fault => {});
    }, [ loading ]);

    // get all checked items in an array.
    const handleSubmit = (event) => {
        const submitData = async () => {
          await setLoading( true );
          const data = await fetch(api, {
            method: 'POST',
            body: JSON.stringify(selectedInterestes)
          })
          ;
        }

       submitData().catch( fault => {
        console.log(fault);
      }).then(async () => {
         await setLoading(false);
      });
    }

    return(
        <>
            <div className={'form'}>
                <div className="facet__filter__items">
                    <ul className="facet__filter--list wdg-mt--md wdg-mb--md wdg-grid-3__md-2_xs-1-xsGutter">
                        {data.map( interest => (
                          <li className="facet__label" key={interest.id}>
                            <Interest_form_item interest={interest} interestsSelected={interestsSelected} />
                          </li>
                        ))}
                    </ul>
                </div>

                <div className="interestform-submit">
                    <button onClick={ handleSubmit } disabled={ loading } className={ buttonClasses } type="submit" name="submit">  <span class="interestform-submit-text">Save My Interests</span></button>
                </div>
            </div>
        </>
    )
}
export default InterestForm;
